import { Navigate, useParams, useSearchParams } from "react-router-dom";

/**
 * /demos/:slug — legacy demo-sprint URLs now redirect into the real V5
 * workbench with the matching in-product tour armed (VERTICAL_DEMOS_V2 D3:
 * the bespoke API-served HTML pages are retired).
 *
 * Known slugs map to the public (anonymous, read-only) view of their seeded
 * demo project with `?tour=<slug>&branch=main`; a `kiosk` query param on the
 * incoming URL is forwarded. Unknown slugs fall back to the app root.
 */
const DEMO_PROJECTS: Record<string, string> = {
  "cfd-traceback": "c0ffee00-0000-4000-8000-000000000001",
  "sc-coverage": "c0ffee00-0000-4000-8000-000000000002",
};

export default function DemoRedirect() {
  const { slug } = useParams<{ slug: string }>();
  const [searchParams] = useSearchParams();
  const projectId = slug ? DEMO_PROJECTS[slug] : undefined;
  if (!slug || !projectId) return <Navigate to="/" replace />;
  const params = new URLSearchParams({ tour: slug, branch: "main" });
  const kiosk = searchParams.get("kiosk");
  if (kiosk !== null) params.set("kiosk", kiosk);
  return <Navigate to={`/public/${projectId}?${params.toString()}`} replace />;
}
